import createSearch from "./search.js";

const load = (db, data) => {
  db.wasm.clear();
  db.wasm.reserve(data.length);
  for (let position = 0; position < data.length; position += 1000)
    db.wasm.load(JSON.stringify(data.slice(position, position + 1000)));
};

export default (app, collection, db, contentType) => {
  collection.on("init", 0, (query) => {
    if (query.storageData?.length) load(db, query.storageData);
    delete query.storageData;
    return query;
  });
  collection.on("init", -1000, () => collection);

  collection.on("size", () => db.wasm.size());
  collection.on("aggregate", ({ filterField, filterValue, groupBy, sum }) =>
    JSON.parse(db.wasm.group_sum(filterField, JSON.stringify(filterValue), groupBy, sum)),
  );
  collection.on("get", 1000, (query) => {
    if (query.data) return query;
    const data = db.wasm.get(query.id);
    return data === undefined ? query : { ...query, data: JSON.parse(data) };
  });
  collection.on("find", 1000, (query) => {
    const { field, value, data, testIfSet } = query;
    if (data) return;
    const result = db.wasm.find(
      field,
      JSON.stringify(testIfSet ? !!value : value === undefined ? null : value),
      !!testIfSet,
      value === undefined,
    );
    return result === undefined ? query : { ...query, data: JSON.parse(result) };
  });

  collection.on("save", 2000, (query) => {
    const id = query.id || (query.data && query.data._id);
    if (!id || query.oldData) return;
    const oldData = db.wasm.get(id);
    if (!oldData) return;
    const parsed = JSON.parse(oldData);
    if (query.fields) query.data = { ...parsed, ...query.data };
    return { ...query, oldData: parsed };
  });
  collection.on("save", 1000, (query) => {
    if (!query.data) return;
    query.data._id = query.id = query.id || query.data._id || app.uuid();
  });
  collection.on("save", -100, (query) => {
    if (!query.data) return;
    db.wasm.save(JSON.stringify(query.data), db.wasm.size());
  });

  collection.on("delete", 1000, (query) => {
    const id = query.id || query.data._id;
    const oldData = db.wasm.get(id);
    return { ...query, id, oldData: oldData && JSON.parse(oldData), data: query.data || { _id: id } };
  });
  collection.on("delete", -200, (query) => {
    if (!query.data) return;
    db.wasm.delete(query.id);
  });

  createSearch(collection, db, contentType);

  collection.on("updates", 1000, async (query) => {
    if (query.saveQueue) {
      for (const [id, data] of Object.entries(query.saveQueue)) {
        if (data === "deleted") {
          await collection.delete({ id, data, session: query.session });
          continue;
        }
        const { data: item } = await collection.get({ id });
        if (!item?._chdate || item._chdate < data._chdate) await collection.save({ data, session: query.session });
      }
      return { ...query, saveQueue: undefined };
    }
    if (!query.date) return query;
    return { ...query, ids: JSON.parse(db.wasm.updates(query.date)) };
  });

  collection.on("clearCache", -1001, () => db.wasm.clear());
};
